export function findDefaultTemplate(templates) {
  return templates.find(template => template.enabled && template.isDefault)
    || templates.find(template => template.enabled)
    || null
}

export function createTemplateSelectionMap(results, currentSelections, defaultTemplateId) {
  const selections = { ...currentSelections }
  for (const result of results) {
    if (result.reportId && !selections[result.reportId]) {
      selections[result.reportId] = defaultTemplateId
    }
  }
  return selections
}

export function createPdfCacheKey(reportId, templateId, templateVersion) {
  return [reportId, templateId, templateVersion].join(':')
}

export function includeTemplateInFilename(filename, templateId) {
  if (!filename || !templateId || filename.endsWith(`_${templateId}.pdf`)) return filename
  return filename.toLowerCase().endsWith('.pdf')
    ? `${filename.slice(0, -4)}_${templateId}.pdf`
    : `${filename}_${templateId}.pdf`
}
